import React from "react";
import { scaleLinear } from "d3-scale";
import { wordwrap } from "d3-jetpack";

const CostByProviderChart = ({ props }) => {
  const width = props.width;
  const height = props.height;

  const margin = {
    top: 50,
    right: 50,
    bottom: 0,
    left: 100,
  };

  const w = width - margin.right - margin.left;
  const h = height - margin.top - margin.bottom;

  const data = props.data.costByProvider;

  const y = scaleLinear().domain([0, 10]).range([h, 0]);

  const GAP = 20;

  return (
    <div>
      <svg width={width} height={height} viewBox={`0 0 ${920} ${200}`}>
        <g transform={`translate(${margin.left}, ${margin.top})`}>
          <g transform={`translate(0, ${200 / 2})`}>
            {data

              .reduce((acc, cur, i) => {
                if (i === 0) {
                  cur.x0 = 0;
                } else {
                  cur.x0 =
                    acc[i - 1].x0 +
                    Math.sqrt(acc[i - 1].cost) * 20 +
                    GAP +
                    Math.sqrt(cur.cost) * 20;
                }

                acc.push(cur);
                return acc;
              }, [])
              .map((d, i) => (
                <g
                  transform={`translate(${i * (920 / 4)}, 0)`}
                  key={`item-${i}`}
                >
                  <circle
                    r={Math.sqrt(d.cost) * (920 / 30)}
                    fill={`hsl(${(i / 4) * 360}, 60%, 40%)`}
                  />
                  <text
                    style={{
                      textAnchor: "middle",
                      dominantBaseline: "middle",
                      fontSize: w < 500 ? 24 : 16,
                    }}
                    fill="black"
                  >
                    {wordwrap(d.provider.replace(/\_/g, " "), 15).map(
                      (token, j) => (
                        <tspan
                          key={`token-${j}`}
                          y={-Math.sqrt(d.cost) * (920 / 30)}
                          x={0}
                          dy={-15 - j * 25}
                        >
                          {token}
                        </tspan>
                      )
                    )}
                  </text>
                  <text
                    style={{
                      textAnchor: "middle",
                      fill: "white",
                      dominantBaseline: "central",
                      fontSize: h / 10,
                      fontWeight: "bold",
                      fontFamily: "Open Sans Condensed",
                    }}
                  >
                    {d.cost}%
                  </text>
                </g>
              ))}
          </g>
        </g>
      </svg>
    </div>
  );
};

export default CostByProviderChart;
